import Model from '@/models/Model'

export default {
    mixins: [
        Model
    ],

    data() {
        return {
            table: 'bars',
            name: 'bar',
            class: 'Modules\\Bar\\Entities\\Bar',
            forms: {},
            defaultBarsForm: 'default-bars-form'
        }
    },

    methods: {
        addForm(barName, component) {
            this.forms[barName] = component

            return this
        },

        getForm(barName) {
            return this.forms[barName] ?? this.defaultBarsForm
        }
    }
}